import React, { useContext } from 'react';
import { Navigate, Outlet } from 'react-router';
import { UserContext } from 'contexts/UserContext';
import Menu from './menu/Menu';

const AuthWrapper = (props) => {
    const { user, token } = useContext(UserContext);

    return user && token ? (
        <div style={{ display: 'flex', flexDirection: 'row', minHeight: '100vh' }}>
            <Menu {...props} />
            <div style={{ flex: 1, backgroundColor: '#F4F4F4' }}>
                <Outlet />
            </div>
        </div>
    ) : (
        <Navigate to="/login" />
    );
};

export default AuthWrapper;
